<div class="w-100 h-100 monitor-dashboard-requests">
  <div class="row">
    <div class="col-md-12 pr-0">
      <div class="card card_layout">
        <div class="card-body p-0">
          <div class="monitor-dashboard-top-tabs px-4 pt-4">
            <v-tabs v-model="topTab" background-color="transparent" color="primary" slider-color="primary" grow
              class="monitor-dashboard-tabs">
              <v-tab class="text-none font-weight-bold">
                {{$t('monitorDashboard.requests')}}
              </v-tab>
              <v-tab class="text-none font-weight-bold">
                {{$t('monitorDashboard.notifications330')}}
              </v-tab>
            </v-tabs>
          </div>

          <v-tabs-items v-model="topTab" class="transparent-tabs-items">
            <v-tab-item>
              <requests v-if="topTab === 0" ref="requestsPage"></requests>
            </v-tab-item>

            <v-tab-item>
              <notifications330-page v-if="topTab === 1" ref="notifications330Page"></notifications330-page>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </div>
  </div>
</div>
